export const INPUT_DATE_SELECT_FORMAT = {
	DATE: 'DATE',
	ISO_STRING: 'ISO_STRING',
	CREDIT_CARD: 'CREDIT_CARD',
	EXPIRATION_DATE: 'EXPIRATION_DATE'
} as const;
export type INPUT_DATE_SELECT_FORMAT = (typeof INPUT_DATE_SELECT_FORMAT)[keyof typeof INPUT_DATE_SELECT_FORMAT];

export type InputSelectOption = {
	value?: number | null;
	label: string;
};

export type DateSelectorOptionsBase = {
	minDate?: Date;
	maxDate?: Date;
	placeholders?: {
		day?: string;
		month?: string;
		year?: string;
	};
};

export type DateSelectorOptionsDate = DateSelectorOptionsBase & {
	value?: Date | null;
	onChange?: (newValue?: Date) => void;
	format: 'DATE';
};

export type DateSelectorOptionsString = DateSelectorOptionsBase & {
	value?: string | null;
	onChange?: (newValue?: string) => void;
	format: 'ISO_STRING' | 'CREDIT_CARD' | 'EXPIRATION_DATE';
};

// export type DateSelectorOptions = DateSelectorOptionsDate | DateSelectorOptionsString;

export type DateSelectorOptions = {
	minDate?: Date;
	maxDate?: Date;
	placeholders?: {
		day?: string;
		month?: string;
		year?: string;
	};
	value?: Date | string | null;
	onChange?: ((newValue?: Date) => void) | ((newValue?: string) => void);
	format: INPUT_DATE_SELECT_FORMAT;
};
